export const enum DATA_SOURCE {
  NORWAY = 'norway',
  JAPAN = 'japan',
  UK = 'united_kingdom',
}
